import React, { useState, useEffect } from "react";
import { linkService } from "../services/linkService";
import "./LinkForm.css";

const LinkForm = ({ link, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({
    originalUrl: "",
    redirectUrls: [""],
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (link) {
      setFormData({
        originalUrl: link.originalUrl || "",
        redirectUrls:
          link.redirectUrls && link.redirectUrls.length > 0
            ? [...link.redirectUrls]
            : [""],
      });
    }
  }, [link]);

  const handleInputChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleRedirectUrlChange = (index, value) => {
    const newRedirectUrls = [...formData.redirectUrls];
    newRedirectUrls[index] = value;
    setFormData({
      ...formData,
      redirectUrls: newRedirectUrls,
    });
  };

  const addRedirectUrl = () => {
    setFormData({
      ...formData,
      redirectUrls: [...formData.redirectUrls, ""],
    });
  };

  const removeRedirectUrl = (index) => {
    if (formData.redirectUrls.length > 1) {
      const newRedirectUrls = formData.redirectUrls.filter(
        (_, i) => i !== index
      );
      setFormData({
        ...formData,
        redirectUrls: newRedirectUrls,
      });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    // Validate
    if (!formData.originalUrl.trim()) {
      setError("Vui lòng nhập link gốc");
      return;
    }

    const validRedirectUrls = formData.redirectUrls.filter((url) => url.trim());
    if (validRedirectUrls.length === 0) {
      setError("Vui lòng nhập ít nhất 1 link redirect");
      return;
    }

    setLoading(true);

    try {
      const data = {
        originalUrl: formData.originalUrl.trim(),
        redirectUrls: validRedirectUrls.map((url) => url.trim()),
      };

      if (link) {
        await linkService.update(link.id, data);
      } else {
        await linkService.create(data);
      }

      onSuccess();
    } catch (err) {
      setError(err.response?.data?.message || "Có lỗi xảy ra");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{link ? "Sửa link" : "Tạo link mới"}</h3>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="link-form">
          <div className="form-group">
            <label htmlFor="originalUrl">Link gốc *</label>
            <input
              type="text"
              id="originalUrl"
              name="originalUrl"
              value={formData.originalUrl}
              onChange={handleInputChange}
              placeholder="http://example.com/dangnhap"
              required
              disabled={loading}
            />
          </div>

          <div className="form-group">
            <label>Link redirect *</label>
            {formData.redirectUrls.map((url, index) => (
              <div key={index} className="redirect-url-input">
                <input
                  type="url"
                  value={url}
                  onChange={(e) =>
                    handleRedirectUrlChange(index, e.target.value)
                  }
                  placeholder="https://example.com/page1"
                  required
                  disabled={loading}
                />
                {formData.redirectUrls.length > 1 && (
                  <button
                    type="button"
                    onClick={() => removeRedirectUrl(index)}
                    className="remove-button"
                    disabled={loading}
                  >
                    Xóa
                  </button>
                )}
              </div>
            ))}
            <button
              type="button"
              onClick={addRedirectUrl}
              className="add-button"
              disabled={loading}
            >
              + Thêm link redirect
            </button>
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="form-actions">
            <button
              type="button"
              onClick={onClose}
              className="cancel-button"
              disabled={loading}
            >
              Hủy
            </button>
            <button type="submit" className="submit-button" disabled={loading}>
              {loading ? "Đang lưu..." : link ? "Cập nhật" : "Tạo mới"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LinkForm;
